import { Designation } from '../app/transaction-store/designation';

const cartMethodQueue = [];
let cartMethodTarget = null;
let cartEmbed = null;

// initialize and dump queue
export function SetCartSource(cartSource, embed) {
  cartMethodTarget = cartSource;
  cartEmbed = embed;

  // cartMethods might just go nowhere if there is no cart listening
  while (cartMethodQueue.length > 0) {
    const entry = cartMethodQueue.shift();
    SendCartMethod(entry.methodName, entry.params);
  }
}

// high level method(s)
export function SetCartDesignations(designations: Designation[]) {
  SendCartMethod('setDesignations', {
    // extract just id and amount from designations before sending out
    designations: designations.map(({ id, amount }) => ({
      designation_id: id,
      amount
    }))
  });
}

export function RemoveCartDesignation(designation: Designation) {
  SendCartMethod('removeDesignation', {
    designation: {
      id: designation.id
    }
  });
}

export function AddOrReplaceCartDesignation(designation: Designation) {
  SendCartMethod('addOrReplaceDesignation', {
    designation: {
      id: designation.id,
      amount: designation.amount
    }
  });
}

// low level methods
export function SendCartMethod(methodName: string, params: any) {
  if (cartMethodTarget === null) {
    cartMethodQueue.push({ methodName, params });
  } else {
    cartMethodTarget.postMessage(
      JSON.stringify({
        embed_id: cartEmbed.id,
        action: 'cartMethod',
        method: methodName,
        params
      }),
      '*'
    );
  }
}
